import encryptionService from '@/Core.Service.Domain/Controls/Controls.Common/Shared/encryptionService.js';

export const getControlById = async (controlType, controlId) => {
  let result = null;
  try {
    if (controlType === 'thermostat') {
      result = await window.axios.get(`/v1/thermostats/${controlId}`);
      return result.data.data;
    } else if (controlType === 'powercontrol') {
      result = await window.axios.get(`/v1/powercontrols/${controlId}`);
      return result.data.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

export const updateControl = async (controlType, controlId, updatedControl) => {
  let result = null;
  try {
    if (controlType === 'thermostat') {
      result = await window.axios.put(`/v1/thermostats/${controlId}`, updatedControl);
      return result.data.data;
    } else if (controlType === 'powercontrol') {
      result = await window.axios.put(`/v1/powercontrols/${controlId}`, updatedControl);
      return result.data.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

export const getAdminAccount = async (siteId) => {
  try {
    const salt = encryptionService.generateSalt();
    const result = await window.axios.get(
      `/v1/controlpermissions/site/${siteId}/admin-login?salt=${salt}`
    );
    const { data } = result.data;
    if (!data) {
      return Promise.reject('No admin account found');
    }
    const decryptedPassword = await encryptionService.decrypt(
      data?.password,
      salt
    );
    const endpoint = `https://${data.account}.officeclimatecontrol.net/login.cgi`;
    return {
      url: endpoint,
      account: data.account,
      user: data.userName,
      pass: decryptedPassword,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getSchedulerAccount = async (siteId) => {
  try {
    const salt = encryptionService.generateSalt();
    const result = await window.axios.get(
      `/v1/controlpermissions/site/${siteId}/scheduler-login?salt=${salt}`
    );
    const { data } = result.data;
    const decryptedPassword = await encryptionService.decrypt(
      data.password,
      salt
    );
    const endpoint = `https://${data.account}.officeclimatecontrol.net/login.cgi#_scheduleCalendarPage`;
    return {
      url: endpoint,
      account: data.account,
      user: data.userName,
      pass: decryptedPassword,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getThermostatSystemModes = async () => {
  return ['Heat', 'Cool', 'Auto', 'Off'];
};

export const getThermostatFanModes = async () => {
  return ['On', 'Auto'];
};

export default {
  getControlById,
  updateControl,
};
